import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import { useLanguage } from "../../context/LanguageContext";
import { WHATSAPP_URL } from "../../i18n/content";

export const WhatsAppButton = () => {
  const { t } = useLanguage();
  return (
    <motion.a
      data-testid="whatsapp-btn"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.label}
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-2.5 h-14 px-4 md:px-5 rounded-full bg-white/70 backdrop-blur-xl border border-white/40 shadow-[0_8px_30px_rgba(10,10,10,0.12)] text-brand-green focus:outline-none focus:ring-2 focus:ring-brand-green"
    >
      <WhatsappLogo size={26} weight="duotone" />
      <span className="hidden md:block text-sm font-bold tracking-wide">{t.whatsapp.label}</span>
    </motion.a>
  );
};
